<template>
  <div>
    <div v-if="field.info.multilingual && field.canRead">
      <template v-for="(language, index) in contentLanguages">
        <h2 :key="index + '-h'">{{ labelText + ' (' + language.code + ')' }}</h2>
        <!-- wysiwyg
          v-if="field.canEdit"
          :key="index"
          v-model="value[field.fieldName + '_' + language.code]"
        / -->
        <textarea
          v-if="field.canEdit"
          v-model="value[field.fieldName + '_' + language.code]"
          :key="index + '-ta'"
          style="width: 100%;  min-height: 300px; border: 1px solid orange;"
        />
        <div
          style="border: 1px solid green; overflow: auto; max-height: 500px; padding: 10px;"
          class="text-left"
          v-html="value[field.fieldName + '_' + language.code]"
        />
        <div v-if="!field.canEdit">{{ value[field.fieldName + '_' + language.code] }}</div>
      </template>
    </div>
    <template v-else-if="field.canRead">
      <h2>{{ labelText }}</h2>

      <wysiwyg
        v-if="field.canEdit"
        v-model="value[field.fieldName]"
        :label="labelText"
      />
      <div v-if="!field.canEdit">{{ value[field.fieldName] }}</div>

      <!-- editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
        <div class="menubar">
          <button :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
            Bold
          </button>
          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.heading({ level: 1 }) }"
            @click="commands.heading({ level: 1 })"
          >
            H1
          </button>
        </div>
      </editor-menu-bar>
      <editor-content :editor="editor" / -->


      <!-- editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
        <div class="menubar">

          <button
            class="menubar__button"
            :class="{ 'is-active': isActive.bold() }"
            @click="commands.bold"
          >
            bold
          </button>

          <button
          class="menubar__button"
          @click="showImagePrompt(commands.image)"
        >
          --image--
        </button>

          <button
						class="menubar__button"
						@click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false })"
					>
						add table.
					</button>

					<span v-if="isActive.table()">
						<button
							class="menubar__button"
							@click="commands.deleteTable"
						>
							del-table.
						</button>
						<button
							class="menubar__button"
							@click="commands.addColumnBefore"
						>
							add_col_before.
						</button>
						<button
							class="menubar__button"
							@click="commands.addColumnAfter"
						>
							add_col_after.
						</button>
						<button
							class="menubar__button"
							@click="commands.deleteColumn"
						>
							delete_col.
						</button>
						<button
							class="menubar__button"
							@click="commands.addRowBefore"
						>
							add_row_before.
						</button>
						<button
							class="menubar__button"
							@click="commands.addRowAfter"
						>
  						add_row_after.
						</button>
						<button
							class="menubar__button"
							@click="commands.deleteRow"
						>
							delete_row.
						</button>
          </span>

        </div>
      </editor-menu-bar>
      <editor-content class="editor__content" :editor="editor" / -->
    </template>
  </div>
</template>

<script>
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
/* import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Image,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  Table,
	TableHeader,
	TableCell,
	TableRow,
  History
} from 'tiptap-extensions' */

export default {
  name: 'FormInput',

  data () {
    return {
      editor: null
    }
  },

  /* components: {
    EditorMenuBar,
    EditorContent
  },*/

  props: {
    ...formElementProps
  },

  beforeDestroy () {
    // this.editor.destroy()
  },

  created () {
    /* this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new BulletList(),
        new OrderedList(),
        new ListItem(),
        new TodoItem(),
        new TodoList(),
        new Bold(),
        new Code(),
        new Image(),
        new Italic(),
        new Link(),
        new Strike(),
        new Underline(),
        new History(),
        new Table({
					resizable: true,
				}),
				new TableHeader(),
				new TableCell(),
				new TableRow()
      ],
      content: this.value[this.field.fieldName]
    })

    this.editor.on('update', ({ getHTML }) => {
      // get new content on update
      this.value[this.field.fieldName] = getHTML()
    }) */
  },

  computed: {
    ...sharedComputed
  },

  methods: {
    ...sharedMethods
  }
}
</script>

<style>
.editr--content {
  text-align: left;
}
.editor__content table td {
  border: 1px solid green;
}
</style>
